import React from 'react';
import { ToggleWrapper } from './ToggleWrapper';
import { ToggledFeature } from './featureToggleService';

export function NewWysiwygStylesConfigurationToggleWrapper(
  props: {
    children: React.ReactNode;
  }
) {
  return (
    <ToggleWrapper feature={ToggledFeature.NEW_WYSIWYG_STYLES_CONFIGURATION}>
      {props.children}
    </ToggleWrapper>
  );
}
